import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo, gql } from 'apollo-angular';
import { ToastService } from '../../shared/toast/toast.service';

const ACCEPT_INVITE_MUTATION = gql`
  mutation AcceptInvite($token: String!, $password: String!) {
    acceptInvite(token: $token, password: $password)
  }
`;

const passwordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
  styleUrls: ['./accept-invite.component.scss'],
  standalone: false,
})
export class AcceptInviteComponent implements OnInit {
  form: FormGroup;
  email = '';
  token = '';
  isSubmitting = false;
  isComplete = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private apollo: Apollo,
    private toast: ToastService,
  ) {
    this.form = this.fb.group(
      {
        password: ['', [Validators.required, Validators.pattern(passwordPolicy)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: matchPasswords },
    );
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
  }

  onSubmit() {
    if (this.form.invalid || this.isSubmitting || !this.token) {
      if (!this.token) this.toast.error('This invite link is missing its token.');
      return;
    }
    this.isSubmitting = true;
    const { password } = this.form.value;
    this.apollo
      .mutate({
        mutation: ACCEPT_INVITE_MUTATION,
        variables: { token: this.token, password },
      })
      .subscribe({
        next: () => {
          this.isSubmitting = false;
          this.isComplete = true;
        },
        error: (err) => {
          this.isSubmitting = false;
          this.toast.error(err?.message || 'Could not accept invite.');
        },
      });
  }

  goToLogin() {
    this.router.navigate(['/login'], { queryParams: { email: this.email } });
  }
}

function matchPasswords(group: AbstractControl): ValidationErrors | null {
  const password = group.get('password')?.value;
  const confirm = group.get('confirmPassword')?.value;
  return password && confirm && password !== confirm ? { passwordMismatch: true } : null;
}
